module.exports = __webpack_public_path__ + "static/media/invoiceActive.674a0af6.svg";